angular.module("dx.webapp.login", [
	"ngCookies",

	"digiexam.components",
	"digiexam.services",
	"digiexam.services.faults",
	"dx.webapp.navigation",
	"dx.webapp.region",
	"dx.webapp.session",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",
]);
